import type { PlatformRecord } from "./sources.js";

export interface PlatformEntry extends PlatformRecord {
  readonly label: string;
  readonly code: string;
}

export const PLATFORM_REGISTRY: readonly PlatformEntry[] = [
  {
    platform: "youtube",
    label: "YouTube",
    code: "YT",
    support_phase: 1,
    collection_state: "collected",
    url_patterns: ["youtube.com", "youtu.be", "youtube-nocookie.com"],
  },
  {
    platform: "x",
    label: "X",
    code: "X",
    support_phase: 1,
    collection_state: "collected",
    url_patterns: ["x.com", "twitter.com"],
  },
  {
    platform: "uk_hansard",
    label: "Hansard",
    code: "HS",
    support_phase: 1,
    collection_state: "collected",
    url_patterns: ["hansard.parliament.uk"],
  },
  {
    platform: "bundestag",
    label: "Bundestag",
    code: "BT",
    support_phase: 1,
    collection_state: "collected",
    url_patterns: ["bundestag.de"],
  },
  {
    platform: "podcast_rss",
    label: "Podcast RSS",
    code: "RSS",
    support_phase: 1,
    collection_state: "collected",
    url_patterns: [],
  },
  {
    platform: "broadcaster",
    label: "Broadcaster",
    code: "TV",
    support_phase: 1,
    collection_state: "collected",
    url_patterns: [],
  },
  { platform: "news", label: "News", code: "NEWS", support_phase: 1, collection_state: "collected", url_patterns: [] },
  { platform: "web", label: "Website", code: "WEB", support_phase: 1, collection_state: "collected", url_patterns: [] },
  {
    platform: "instagram",
    label: "Instagram",
    code: "IG",
    support_phase: 3,
    collection_state: "known_not_collected",
    url_patterns: ["instagram.com"],
  },
  {
    platform: "bluesky",
    label: "Bluesky",
    code: "BSKY",
    support_phase: null,
    collection_state: "future_only",
    url_patterns: ["bsky.app"],
  },
  {
    platform: "tiktok",
    label: "TikTok",
    code: "TT",
    support_phase: null,
    collection_state: "future_only",
    url_patterns: ["tiktok.com"],
  },
  {
    platform: "facebook",
    label: "Facebook",
    code: "FB",
    support_phase: null,
    collection_state: "future_only",
    url_patterns: ["facebook.com", "fb.com", "fb.watch"],
  },
  {
    platform: "linkedin",
    label: "LinkedIn",
    code: "IN",
    support_phase: null,
    collection_state: "future_only",
    url_patterns: ["linkedin.com"],
  },
  {
    platform: "truth_social",
    label: "Truth Social",
    code: "TS",
    support_phase: null,
    collection_state: "future_only",
    url_patterns: ["truthsocial.com"],
  },
];

export const WEB_PLATFORM = "web";

export function platformEntry(platform: string): PlatformEntry | undefined {
  return PLATFORM_REGISTRY.find((p) => p.platform === platform);
}

export function platformLabel(platform: string): string {
  return platformEntry(platform)?.label ?? platform;
}

export function platformForHost(host: string): PlatformEntry | undefined {
  const h = host.toLowerCase();
  return PLATFORM_REGISTRY.find((p) => p.url_patterns.some((pattern) => h === pattern || h.endsWith(`.${pattern}`)));
}
